import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

// Language chosen by visitors on the public pages and the signed-out app pages (login, signup, password reset).
// Signed-in users follow their profile locale.
export const LOCALES = ['pt_BR', 'en'];
export const LOCALE_CHOICES = ['auto', ...LOCALES];

export const getLocaleChoice = () => {
  const choice = LocalStorage.get(LOCAL_STORAGE_KEYS.GUEST_LOCALE);
  return LOCALE_CHOICES.includes(choice) ? choice : 'auto';
};

export const saveLocaleChoice = choice => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.GUEST_LOCALE, choice);
};

export const browserLocale = (languages = navigator.languages) => {
  const tags = (languages || []).map(tag => tag.replace('-', '_'));
  const exact = tags.find(tag => LOCALES.includes(tag));
  if (exact) return exact;

  const base = tags
    .map(tag => tag.split('_')[0])
    .find(language => LOCALES.some(locale => locale.startsWith(language)));
  return base ? LOCALES.find(locale => locale.startsWith(base)) : null;
};

// "auto" follows the browser and falls back to the server's DEFAULT_LOCALE.
export const resolveLocale = (choice, fallback) => {
  if (choice !== 'auto') return choice;
  return browserLocale() || fallback;
};
